var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import cartUtil from '../helpers/cartUtil';
const getShippingSourceForVariant = (data, currentMarketCode) => {
    const rawLocations = Array.isArray(data.levels) ? data.levels : [];
    const fulfillmentLocations = rawLocations.map((location) => (Object.assign(Object.assign({}, location), { country_code: (location.country_code || '').toUpperCase() })));
    const locationsInCurrentMarket = fulfillmentLocations.filter((location) => location.country_code === currentMarketCode);
    const variantInventoryNotTracked = fulfillmentLocations.length > 0 && fulfillmentLocations.every((location) => location.available === null);
    if (variantInventoryNotTracked) {
        if (currentMarketCode === 'US' &&
            fulfillmentLocations.length === 1 &&
            fulfillmentLocations[0].country_code === 'AU') {
            return 'none';
        }
        return locationsInCurrentMarket.length > 0 ? 'local' : 'international';
    }
    const locationsInCurrentMarketWithStock = locationsInCurrentMarket.some((location) => typeof location.available === 'number' && location.available > 0);
    if (locationsInCurrentMarketWithStock) {
        return 'local';
    }
    const otherMarketsWithStock = fulfillmentLocations.filter((loc) => loc.country_code !== currentMarketCode && typeof loc.available === 'number' && loc.available > 0);
    if (otherMarketsWithStock.length > 0) {
        if (currentMarketCode === 'US' &&
            otherMarketsWithStock.length === 1 &&
            otherMarketsWithStock[0].country_code === 'AU') {
            return 'none';
        }
        return 'international';
    }
    return 'none';
};
const fetchAndRenderInventory = (block, cartItems) => __awaiter(void 0, void 0, void 0, function* () {
    if (!block)
        return;
    const spanElement = block.querySelector('span');
    if (!cartItems || cartItems.length === 0) {
        spanElement.innerHTML = '';
        return;
    }
    try {
        // Show loader while fetching
        spanElement.innerHTML = '...';
        const currentMarketCode = (block.getAttribute('data-current-market') || '').trim().toUpperCase();
        if (!currentMarketCode) {
            spanElement.innerHTML = '';
            return;
        }
        const variantIds = cartItems.map((item) => item.variant_id);
        const inventoryResponses = yield Promise.all(variantIds.map((variantId) => __awaiter(void 0, void 0, void 0, function* () {
            const res = yield fetch(`https://th-admin-api.netlify.app/.netlify/functions/inventory?variant_id=${variantId}`);
            if (!res.ok)
                throw new Error('API error');
            return res.json();
        })));
        const shippingSources = inventoryResponses.map((data) => getShippingSourceForVariant(data, currentMarketCode));
        const shippingMessages = window.thCartShippingMessages || {
            fromCountryWarehouse: 'Ships from our {{ country }} Warehouse for faster delivery',
            internationalWarehouse: 'Ships from our International Warehouse',
        };
        let shippingMessage = '';
        // Worst case wins: international > local > none
        if (shippingSources.includes('international')) {
            shippingMessage = shippingMessages.internationalWarehouse;
        }
        else if (shippingSources.includes('local')) {
            shippingMessage = shippingMessages.fromCountryWarehouse.replace('{{ country }}', currentMarketCode);
        }
        spanElement.innerHTML = shippingMessage;
        // Verify the update wasn't overwritten by cart drawer refresh
        setTimeout(() => {
            const freshContainer = document.querySelector('[data-cart-localised-shipping-container]');
            const freshSpan = freshContainer === null || freshContainer === void 0 ? void 0 : freshContainer.querySelector('span');
            if (freshSpan && freshSpan.innerHTML === '...') {
                // Cart drawer refresh overwrote our update, re-apply
                freshSpan.innerHTML = shippingMessage;
            }
        }, 100);
    }
    catch (err) {
        console.error(err);
        spanElement.innerHTML = '';
    }
});
const updateLocalisedShipping = (cartItems) => __awaiter(void 0, void 0, void 0, function* () {
    const shippingContainer = document.querySelector('[data-cart-localised-shipping-container]');
    // Use provided cart items or fetch if not available
    if (cartItems) {
        fetchAndRenderInventory(shippingContainer, cartItems);
    }
    else {
        const cart = yield cartUtil.get();
        fetchAndRenderInventory(shippingContainer, cart.items);
    }
});
const localisedShipping = (cartItems) => {
    updateLocalisedShipping(cartItems);
};
export { localisedShipping };
